import { EAnalyticsEvents } from '@/_analytic/_types';
import { sendAnalyticsEvent } from '@/_analytic/send-analytics-event';
import { TArticleFeedbackEventParams } from './_types';

export const articleFeedbackEvent = (params: TArticleFeedbackEventParams) => {
  sendAnalyticsEvent({
    name: EAnalyticsEvents.ARTICLE_RATE_SEND_CLICK,
    params,
  });
};
